import { BANNER_LANDING_COUNTER_WARNING_MARGIN } from "../../models/banners";

/**
 * Contador de caracteres de la spec §3.3: visible SIEMPRE (no solo en focus), en warning en los
 * últimos caracteres y en error si el valor llegó pasado del tope.
 *
 * El error en rojo no debería verse nunca escribiendo, porque los campos bloquean el ingreso al
 * llegar al límite; queda para el caso en que el valor viene de la API por encima del tope (un
 * banner cargado antes de que existiera el límite) y hay que mostrar por qué no guarda.
 */
interface BannerCharCounterProps {
  value: number;
  max: number;
  /** Qué se está contando, para el lector de pantalla. Ej: "título de la landing". */
  label: string;
}

export const BannerCharCounter = ({ value, max, label }: BannerCharCounterProps) => {
  const over = value > max;
  const near = !over && value >= max - BANNER_LANDING_COUNTER_WARNING_MARGIN;
  const color = over ? "var(--error-default)" : near ? "var(--warning-default)" : undefined;

  return (
    <small
      className={`banner-char-counter text-right${color ? "" : " text-600"}`}
      style={color ? { color } : undefined}
      aria-live="polite"
      aria-label={`Caracteres del ${label}`}
    >
      {value}/{max}
    </small>
  );
};
